import { WebViewerInstance } from '@pdftron/webviewer';
import { createSlice } from '@reduxjs/toolkit';

import { ICompareDocx } from '../../interfaces/ICompareDocx';
import { IDraft } from '../../interfaces/IDraft';
import { draftApi } from '../../redux/services/draftApi';
import type { RootState } from '../../redux/store';

const initialState = {
  fileLink: null,
  draft: null,
  instance: null,
  selectedText: null,
  citation: null,
} as {
  fileLink: string | null;
  draft: IDraft | null;
  instance: WebViewerInstance | null;
  connectedDrafts: IDraft[] | null;
  compareDocx: ICompareDocx;
  selectedText: string | null;
  citation: { title: string; url: string } | null;
};

const draftSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setInstance: (state, action) => {
      state.instance = action.payload;
    },
    setSelectedText: (state, action) => {
      state.selectedText = action.payload;
    },
    setCitation: (state, action) => {
      state.citation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      draftApi.endpoints.getDocument.matchFulfilled,
      (state, action) => {
        state.fileLink = action.payload.presigned_url;
      }
    );
    builder.addMatcher(
      draftApi.endpoints.getDraft.matchFulfilled,
      (state, action) => {
        state.draft = action.payload;
      }
    );
    builder.addMatcher(
      draftApi.endpoints.getConnectedDraft.matchFulfilled,
      (state, action) => {
        state.connectedDrafts = action.payload.results as IDraft[];
      }
    );
    builder.addMatcher(
      draftApi.endpoints.getCompareDraft.matchFulfilled,
      (state, action) => {
        state.compareDocx = action.payload.results;
      }
    );
  },
});

export const { setInstance, setSelectedText, setCitation } = draftSlice.actions;

export default draftSlice.reducer;

export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
